export const statCards = [
	{
		id: 'income',
		titleId: 'FinPathDashboardCartID1',
		emptyChangeId: 'FinPathDashboardCartID10',
		path: '/income',
	},
	{
		id: 'expenses',
		titleId: 'FinPathDashboardCartID5',
		emptyChangeId: 'FinPathDashboardCartID10',
		path: '/expenses',
	},
	{
		id: 'goal',
		titleId: 'FinPathDashboardCartID7',
		emptyChangeId: 'FinPathDashboardCartID9',
		path: '/goals',
	},
	{
		id: 'balance',
		titleId: 'FinPathDashboardCartID3',
		emptyChangeId: 'FinPathDashboardCartID10',
		path: '/transactions',
	},
];
